import { Component } from 'components/dashboard';

/** @ngInject */
export default function dashboardRouter($stateProvider) {
    const baseState = {
        url: '/dashboard',
        views: {
            content: {
                component: Component.selector
            }
        }
    };

    $stateProvider
        .state('main.dashboard', baseState);
}



// WEBPACK FOOTER //
// ./app/components/dashboard/dashboard.router.js